import { useState } from 'react'
import { useDetectClickOutside } from 'react-detect-click-outside'
import { useDispatch, useSelector } from 'react-redux'

import styles from './sort-by-dropdown.module.scss'
import { Button, ButtonHierarchy } from '@/components/styleguide/Button'
import { constants } from '@/lib/constants'
import { addToDataLayer } from '@/lib/utilities/vehicle'
import { storeSearchParameters } from '@/store/reducers/search'
import { selectSortBy } from '@/store/selectors/search'
import { selectExperiment } from '@/store/selectors/user'
import { Size } from '@/types/system'

export const SortByDropdown = () => {
  const dispatch = useDispatch()
  const sortBy = useSelector(selectSortBy)
  const experiment = useSelector(selectExperiment)

  const [isOptionsOpen, setIsOptionsOpen] = useState(false)
  const [selectedOption, setSelectedOption] = useState(sortBy)

  const toggleOptions = () => {
    setIsOptionsOpen(isOptionsOpen => !isOptionsOpen)
  }

  const closeOptions = () => {
    setIsOptionsOpen(false)
  }

  const onChange = sortId => {
    dispatch(
      storeSearchParameters({
        filter: 'sortBy',
        value: Number(sortId),
      }),
    )
  }

  const handleKeyDown = item => e => {
    switch (e.key) {
      case ' ':
      case 'SpaceBar':
      case 'Enter':
        e.preventDefault()
        setSelectedOption(item)
        setIsOptionsOpen(false)
        onChange(constants.searchSortingOptions[item].value)
        break
      default:
        break
    }
  }

  const ref = useDetectClickOutside({ onTriggered: closeOptions })

  return (
    <div ref={ref}>
      <Button
        size={Size.Medium}
        label="Sort by"
        hierarchy={ButtonHierarchy.Outline}
        hasBackground={false}
        iconPosition="right"
        icon="ChevronDown"
        aria-haspopup="listbox"
        aria-expanded={isOptionsOpen}
        id="sort-by"
        onClick={toggleOptions}
      />
      <ul
        className={`${styles.options} ${isOptionsOpen ? styles.show : ''}`}
        tabIndex={-1}
        role="listbox"
        aria-activedescendant={Object.keys(constants.searchSortingOptions)[0]}>
        {Object.keys(constants.searchSortingOptions).map(item => (
          <li
            tabIndex={0}
            key={item}
            id={item}
            role="option"
            aria-selected={selectedOption === item}
            onKeyDown={handleKeyDown(item)}
            onClick={() => {
              if (selectedOption === constants.searchSortingOptions[item].value) {
                setIsOptionsOpen(false)
                return
              }

              setSelectedOption(constants.searchSortingOptions[item].value)
              setIsOptionsOpen(false)
              addToDataLayer({
                event: 'search-filter',
                'filter-event': 'sort-by',
                'filter-label': constants.searchSortingOptions[item].label,
                experimentGroup: experiment.group,
              })
              onChange(constants.searchSortingOptions[item].value)
            }}>
            {constants.searchSortingOptions[item].label}
          </li>
        ))}
      </ul>
    </div>
  )
}
